/**
 * MUSKLE Bee Hive — partner page sticky subnav scrollspy (John, Mia, FitClub, Lina).
 * Scopes to [data-bh-partner-page]; does not modify the global Shopify header.
 */
(function (global) {
  'use strict';

  var ACTIVE_CLASS = 'is-active';

  function prefersReducedMotion() {
    try {
      return global.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function isPartnerScrollMode() {
    return (
      document.body.classList.contains('bh-partner-page-active') ||
      !!document.querySelector('[data-bh-partner-page]')
    );
  }

  function readHeaderHeight() {
    if (isPartnerScrollMode()) return 0;
    try {
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      if (!isNaN(v) && v > 0) return v;
    } catch (e) {
      /* ignore */
    }
    var header =
      document.querySelector('.header-section') ||
      document.querySelector('#header-group') ||
      document.querySelector('header.header');
    if (header) {
      var h = header.getBoundingClientRect().height;
      if (h > 0) return h;
    }
    return 0;
  }

  function getStickyTopbar(root) {
    return (
      root.querySelector('[data-bh-partner-topbar]') ||
      root.querySelector('.topbar') ||
      root.querySelector('.muskle-bh-coach-page__topbar') ||
      root.querySelector('.muskle-bh-partner-club__topbar') ||
      root.querySelector('.muskle-bh-partner-wellness__topbar')
    );
  }

  function getScrollOffset(root) {
    var headerH = readHeaderHeight();
    var topbar = getStickyTopbar(root);
    var topbarH = topbar ? topbar.getBoundingClientRect().height : 0;
    return Math.round(headerH + topbarH + 12);
  }

  function applyScrollPadding(root) {
    var offset = getScrollOffset(root) + 'px';
    try {
      document.documentElement.style.scrollPaddingTop = offset;
    } catch (e) {
      /* ignore */
    }
    root.style.scrollPaddingTop = offset;
    var shell = root.querySelector('.muskle-bh-influencer-page__shell');
    if (shell) shell.style.scrollPaddingTop = offset;
  }

  function init(root, options) {
    if (!root || root.getAttribute('data-bh-partner-nav-ready') === '1') return;
    options = options || {};

    var nav =
      root.querySelector('[data-bh-partner-nav]') ||
      root.querySelector('.topnav') ||
      root.querySelector('.muskle-bh-coach-page__nav') ||
      root.querySelector('.muskle-bh-partner-club__topnav') ||
      root.querySelector('.muskle-bh-partner-wellness__topnav');
    if (!nav) return;

    applyScrollPadding(root);

    var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    var byId = {};
    var sectionIds = [];
    links.forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.length < 2) return;
      var id = href.slice(1);
      if (!id || byId[id]) return;
      var el = document.getElementById(id);
      if (!el) return;
      byId[id] = a;
      sectionIds.push(id);
    });
    if (!sectionIds.length) return;

    var lastId =
      options.lastSectionId ||
      root.getAttribute('data-bh-partner-last') ||
      sectionIds[sectionIds.length - 1];

    var activeClass = options.activeClass || ACTIVE_CLASS;
    var threshold = typeof options.threshold === 'number' ? options.threshold : 0.3;

    function setActive(id) {
      links.forEach(function (a) {
        a.classList.remove(activeClass);
        a.removeAttribute('aria-current');
      });
      var link = byId[id];
      if (link) {
        link.classList.add(activeClass);
        link.setAttribute('aria-current', 'true');
      }
    }

    function computeActive() {
      var line = global.innerHeight * threshold;
      var active = sectionIds[0];
      sectionIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        if (el.getBoundingClientRect().top <= line) active = id;
      });
      var doc = document.documentElement;
      if (global.scrollY + global.innerHeight >= doc.scrollHeight - 8) active = lastId;
      setActive(active);
    }

    var scrollTimer;
    function onScroll() {
      if (scrollTimer) global.cancelAnimationFrame(scrollTimer);
      scrollTimer = global.requestAnimationFrame(computeActive);
    }

    function scrollToSection(id, updateHash) {
      var el = document.getElementById(id);
      if (!el) return;
      var top = el.getBoundingClientRect().top + global.scrollY - getScrollOffset(root);
      if (top < 0) top = 0;
      global.scrollTo({
        top: top,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
      if (updateHash !== false) {
        try {
          history.pushState(null, '', '#' + id);
        } catch (e) {
          location.hash = id;
        }
      }
      setActive(id);
    }

    nav.addEventListener('click', function (e) {
      var t = e.target.closest('a[href^="#"]');
      if (!t || !nav.contains(t)) return;
      var id = t.getAttribute('href').slice(1);
      if (!id || !byId[id]) return;
      e.preventDefault();
      scrollToSection(id, true);
    });

    global.addEventListener('scroll', onScroll, { passive: true });
    global.addEventListener('resize', function () {
      applyScrollPadding(root);
      onScroll();
    }, { passive: true });

    global.addEventListener('hashchange', function () {
      var h = (location.hash || '').replace(/^#/, '');
      if (h && byId[h]) setActive(h);
    });

    if (location.hash) {
      var hid = location.hash.replace(/^#/, '');
      if (byId[hid]) {
        global.requestAnimationFrame(function () {
          scrollToSection(hid, false);
        });
      } else {
        computeActive();
      }
    } else {
      computeActive();
    }

    root.setAttribute('data-bh-partner-nav-ready', '1');
  }

  function boot() {
    var roots = document.querySelectorAll('[data-bh-partner-page]');
    if (roots.length) {
      document.documentElement.classList.add('bh-partner-page-active');
      document.body.classList.add('bh-partner-page-active');
    }
    for (var i = 0; i < roots.length; i++) {
      init(roots[i]);
    }
  }

  global.MuskleBeeHivePartnerNav = {
    init: init,
    getScrollOffset: getScrollOffset,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(window);
